import React, { Dispatch, SetStateAction } from 'react'
import { ActivityIndicator } from 'react-native'
import styled from 'styled-components/native'
import Show from '@components/Show'
import QueryError from '@components/QueryError'
import LoginNotice from './LoginNotice'
import NoWorkOrdersNotice from './NoWorkOrdersNotice'
import NoCompanyNotice from './NoCompanyNotice'
import FilteredWorkOrders from './FilteredWorkOrders'
import WorkOrderFilters from './WorkOrderFilters'
import { useCurrentUser } from '@context/CurrentUserContext'
import useNavigation from '@hooks/useNavigation'
import { i18n } from '@lib/i18n'

const COPY = i18n.en.WORK_ORDERS.LIST

const Wrapper = styled.View`
  position: relative;
  margin-top: 25px;
`

const Header = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

const HeaderText = styled.Text`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`

interface WorkOrdersProps {
  loading: boolean
  error?: unknown
  workOrders?: WorkOrder[]
  statusFilter?: WorkOrderStatusName
  setStatusFilter: Dispatch<SetStateAction<WorkOrderStatusName | undefined>>
}

const WorkOrders: React.VFC<WorkOrdersProps> = (props) => {
  const { error, loading, workOrders, statusFilter, setStatusFilter } = props
  const { userAuthenticated, userHasCompany } = useCurrentUser()
  const navigation = useNavigation()

  return (
    <Wrapper>
      <Header>
        <HeaderText>{COPY.ACTIVE_WORK_ORDERS}</HeaderText>
        <WorkOrderFilters
          setStatusFilter={setStatusFilter}
        />
      </Header>

      <Show when={userAuthenticated}>
       <Show when={loading}>
         <ActivityIndicator />
       </Show>

       <Show when={workOrders?.length === 0 && userHasCompany}>
         <NoWorkOrdersNotice />
       </Show>

       <Show when={!loading && !userHasCompany}>
         <NoCompanyNotice />
       </Show>

       <Show when={error && !userHasCompany}>
         <QueryError text={ COPY.LOAD_FAILED } />
       </Show>
     </Show>

     <Show when={!userAuthenticated}>
        <LoginNotice />
     </Show>

     <FilteredWorkOrders
       goToWorkOrder={
         (workOrderNumber: number) =>
           navigation.navigate('workOrderView', { workOrderNumber })
       }
       workOrders={workOrders as WorkOrder[]}
       statusFilter={statusFilter}
     />

    </Wrapper>
  )
}

export default WorkOrders
